var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg65(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8398 38.2813H35.9375V24.7461L25 35.6836L14.0625 24.7461V38.2813H3.80859C8.22266 45.3125 16.0547 50 24.9805 50C33.9062 50 41.7383 45.3125 46.1523 38.2813H45.8398Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84766 33.0664V12.2461L25 28.3984L41.1523 12.2461V33.0859H48.6719C49.5312 30.5469 50.0195 27.832 50.0195 25.0195C50 11.1914 38.8086 0 25 0C11.1914 0 0 11.1914 0 25C0 27.832 0.46875 30.5469 1.34766 33.0664H8.84766Z",
    fill: "#FF6600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg65);
export default __webpack_public_path__ + "static/media/65.72aa00c97ad283eda77643a1db839094.svg";
export { ForwardRef as ReactComponent };